document.addEventListener("DOMContentLoaded", () => {

  function getPrices() {
    // CURRENT (sale OR regular)
    const currentPriceEl = document.querySelector(".technow-price-current");
    const currentPrice = currentPriceEl ? currentPriceEl.textContent.trim() : "";

    // COMPARE AT (striked price)
    const comparePriceEl = document.querySelector(".technow-price-compare");
    const comparePrice = comparePriceEl ? comparePriceEl.textContent.trim() : "";

    return {
      final: currentPrice,
      compare: comparePrice
    };
  }

  function updateButton() {
    const button = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!button) return;

    const btnText = button.querySelector(".btn-text");
    if (!btnText) return;

    const { final, compare } = getPrices();

    if (!final) return;

    let html = `
      <span>Ajouter au panier</span>
      <span>|</span>
      <span class="prices-items-collection">
    `;

    if (compare) {
      html += `
        <span class="price-item--regular">
          <span class="promo">promo</span>
          <span class="price-item-collection_atc">${compare}</span>
        </span>
      `;
    }

    html += `
        <span class="product-card__button-price--new">${final}</span>
      </span>
    `;

    btnText.innerHTML = html;
  }

  // Update once per second (theme updates variant price dynamically)
  // setInterval(updateButton, 1000);

  // updateButton();
});  